import React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import './App.css'
import { persistor, store } from './redux/store'
import Main from './navigation/Main'

function App() {
  return (
    <>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <div className="App" style={{ minHeight: '100vh' }}>
            <Main />
          </div>
        </PersistGate>
      </Provider>
    </>
  )
}

export default App
